import { useQuery } from '@tanstack/react-query';

import { searchKeys } from '@/shared/lib/query/queryKeys';

import type { FilterState } from '@/entities/discovery/domain/types';

import { searchIntegration } from '@/features/dataSearch/api/integrationSearchApi';

type UseGetSearchSuggestionsOptions = {
  searchQuery: string;
  filters: FilterState;
  enabled?: boolean;
};

export const useSearchSuggestionsData = ({ searchQuery, filters }: UseGetSearchSuggestionsOptions) => {
  const trimmedQuery = searchQuery.trim();

  const {
    data: searchSuggestions = [],
    isLoading,
    isError,
    isPaused,
    error,
    refetch,
  } = useQuery({
    queryKey: searchKeys.searchSuggestions(trimmedQuery, filters),
    queryFn: async () => {
      if (!trimmedQuery) return [];

      return await searchIntegration(trimmedQuery, filters);
    },
    enabled: trimmedQuery.length > 0,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  return {
    searchSuggestions,
    isLoading,
    isError,
    isPaused,
    error,
    refetch,
  };
};
